import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {useState} from 'react';
import {CreateAdminDTO, useAdmins} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseAddAdminFormProps = {
  setOpen: (open: boolean) => void;
};

export const useAddAdminForm = ({setOpen}: UseAddAdminFormProps) => {
  const {emailSchema, displayNameSchema} = useSchemes();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {createAdminMutation} = useAdmins();

  const onSubmit = async (values: CreateAdminDTO) => {
    setErrorMessage(null);
    try {
      await createAdminMutation.mutateAsync(values);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при создании администратора');
    }
  };

  const formik = useFormik({
    initialValues: {
      displayName: '',
      email: '',
    },
    validationSchema: Yup.object({
      displayName: displayNameSchema,
      email: emailSchema,
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createAdminMutation.isPending,
    submitError: createAdminMutation.error
      ? (createAdminMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    resetForm: formik.resetForm,
    submitForm: () => formik.handleSubmit(),
  };
};
